import type { TextVariants } from "@/components/ui/baseUi/text"
import { PriceObjectEntity } from "@modules/common/priceObject/entities/priceObjectEntity"
import { word } from "@modules/core/utils/i18n"
import { currencySymbol, formatCurrency } from "@modules/currency/currency"
import { useLanguage } from "@modules/language/hooks/useLanguage"
import type { VariantProps } from "class-variance-authority"
import { Text } from "@/components/ui/baseUi/text"

type CurrencyFormattedPriceProps = {
  price?: PriceObjectEntity
  wholePartFontStyle?: VariantProps<typeof TextVariants>["fontStyle"]
  decimalPartFontStyle?: VariantProps<typeof TextVariants>["fontStyle"]
} & React.ComponentProps<"div">

export const CurrencyFormattedPrice = ({
  price,
  wholePartFontStyle,
  decimalPartFontStyle,
  ...props
}: CurrencyFormattedPriceProps) => {
  const language = useLanguage()
  if (!price) return <Text fontStyle="HS">{word("programBundle.form.pricing.free")}</Text>
  const symbol = currencySymbol(price.currency, language)
  const formattedPrice = formatCurrency(price.value, price.currency, language).replace(symbol, "")
  const [wholePart, decimalPart] = formattedPrice.split(",")

  return (
    <div className="whitespace-nowrap" {...props}>
      <Text fontStyle={wholePartFontStyle ?? "DM"}>{wholePart}</Text>
      <Text fontStyle={decimalPartFontStyle ?? "HL"}>{decimalPart ? `,${decimalPart}${symbol}` : ` ${symbol}`}</Text>
    </div>
  )
}
